import { CollectionMetadata as GQLCollectionMetadata } from '../../generated/graphql';
import * as CollectionMetadata from './CollectionMetadata';

export type GqlCollection<T> = {
  collection: T[];
  metadata: CollectionMetadata.CollectionMetadata;
};

export const fromGql = <
  T,
  U,
  V extends {
    collection: U[];
    metadata: GQLCollectionMetadata;
  },
>(
  collection: V,
  collectionDeserializer: (items: U[]) => T[],
): GqlCollection<T> => ({
  metadata: CollectionMetadata.fromGql(collection.metadata),
  collection: collectionDeserializer(collection.collection),
});
